<div id="monitoring-print">
    <div *ngFor="let tab of results.tabs">
        <div *ngFor="let graph of tab.graphs" class="graph">
            <app-monitoring-graph-modal [graph]="graph"></app-monitoring-graph-modal>
        </div>
    </div>
    <div class="print-mask">
        <h3>{{ 'reports.exportMessage.summary' | translate }}</h3>
        <mat-spinner [diameter]="35" color="accent" ></mat-spinner>
    </div>
</div>
